/**
 * Posture Analysis opens on the client's latest saved analysis (by date), unless the page
 * already has work of its own: an analysis picked from a link, a restored draft, captured
 * images, or stills handed over from Remote Assessment "Review & save".
 *
 * The Remote Assessment case matters for data: the handed-over stills arrive only once the
 * pose model is ready, usually after the analyses list. Opening the latest analysis first would
 * load the new stills into it, and Save would overwrite that earlier analysis.
 */
export interface AutoLoadLatestInput {
  /** Analysis id from the URL (`?analysisId=`), loaded by its own effect. */
  autoLoadAnalysisId: string | null | undefined;
  clientId: string | undefined;
  canLoad: boolean;
  draftCheckResolved: boolean;
  draftWasRestored: boolean;
  alreadyAutoLoaded: boolean;
  selectedAnalysisId: string | null | undefined;
  isLoading: boolean;
  isClientLoading: boolean;
  /** The client's saved analyses, latest first. */
  priorAnalysisIds: readonly string[];
  hasCurrentWork: boolean;
  /** The page was opened from Remote Assessment "Review & save" (`?remoteHandoff=`). */
  isRemoteHandoff: boolean;
}

/** The analysis id to open automatically, or null to start a new analysis. */
export function latestAnalysisToAutoLoad(input: AutoLoadLatestInput): string | null {
  if (
    input.autoLoadAnalysisId ||
    input.isRemoteHandoff ||
    !input.clientId ||
    !input.canLoad ||
    !input.draftCheckResolved ||
    input.draftWasRestored ||
    input.alreadyAutoLoaded ||
    input.selectedAnalysisId ||
    input.isLoading ||
    input.isClientLoading ||
    input.hasCurrentWork
  ) {
    return null;
  }
  return input.priorAnalysisIds[0] ?? null;
}
